export default __webpack_public_path__ + "static/media/plus.17f48809.svg";